import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { ColumnFilterOp, DateColumnDefinition } from "./datatable.component";

export class DateFilterOperator {
    public text: string;
    public value: ColumnFilterOp;

    constructor(text: string, value: ColumnFilterOp) {
        this.text = text;
        this.value = value;
    }
}

@Component({
    selector: "date-filter",
    templateUrl: "./dateFilter.component.html",
    styleUrls: ["./dateFilter.component.css"],
    standalone: false
})
export class DateFilterComponent {
    @Input() public index: number;
    @Input() public columnDefinition: DateColumnDefinition;
    @Input() public data: any[][];
    @Output() public filterUpdated: EventEmitter<void> = new EventEmitter<void>();
    public filterOp: DateFilterOperator = new DateFilterOperator("=", ColumnFilterOp.Equal);
    public selectedDate: any;

    public readonly filterOps: DateFilterOperator[] = [
        new DateFilterOperator("<", ColumnFilterOp.Less),
        new DateFilterOperator("<=", ColumnFilterOp.LessEqual),
        new DateFilterOperator("=", ColumnFilterOp.Equal),
        new DateFilterOperator(">=", ColumnFilterOp.GreaterEqual),
        new DateFilterOperator(">", ColumnFilterOp.Greater),
    ];

    @ViewChild("opSelectorToggle") private opSelectorToggle: ElementRef;
    @ViewChild("popupContents") private popupContents: ElementRef;

    public toggleCalendar(event: Event, datePicker: any) {
        event.stopPropagation();
        datePicker.toggle();
    }

    public performChecks(event: Event, datePicker: any) {
        let pickers = this.popupContents.nativeElement.getElementsByTagName("ngb-datepicker");
        if (pickers && pickers.length > 0) {
            datePicker.toggle();
            event.stopPropagation();
        }
    }

    public opSelected(filterOp: DateFilterOperator) {
        let dropdown: any = this.opSelectorToggle;
        this.filterOp = filterOp;
        dropdown.close();

        this.columnDefinition.filterOp = this.filterOp.value;
        this.columnDefinition.filterTerm = [this.selectedDate];
        this.filterUpdated.emit();
    }

    public dateSelected(datePicker: any) {
        datePicker.toggle();

        this.columnDefinition.filterOp = this.filterOp.value;
        this.columnDefinition.filterTerm = [this.selectedDate];
        this.filterUpdated.emit();
    }

    public clear(event: Event) {
        this.selectedDate = null;
        event.stopPropagation();
    }
}